import { Model, MapTo } from 'src/app/decorators/mapto';

export class TaxModel extends Model {
    @MapTo()
    organization_id: string;
    @MapTo()
    name: string;
    @MapTo()
    rate: number;
    @MapTo()
    status: number;

    constructor(payload: any) {
        super(payload);
        this.setValues(payload);
    }
}
